// extracted by mini-css-extract-plugin
export default {"wrap":"SurveyAddRow_wrap__O0ebu","addBtn":"SurveyAddRow_addBtn__NJtjZ","addBtnIcon":"SurveyAddRow_addBtnIcon__RnxCD"};